import { c as _c } from "react/compiler-runtime";
import type { KingFanUpMessage } from '@module/types/centrifuge/public-message/upMessageTypes';
interface Props {
  item: KingFanUpMessage;
}
export default function KingFanUpChat(props) {
  const $ = _c(2);
  const {
    item
  } = props;
  const {
    message
  } = item.data;
  const t0 = `축하합니다! ${message.nick}님께서 팬클럽 회장이 되셨습니다! 회장님께 다함께 박수~`;
  let t1;
  if ($[0] !== t0) {
    t1 = <div className="mb-[3px] whitespace-pre-wrap text-cht_al_3"><div>{t0}</div></div>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}